import * as types from './actionTypes';

export function showLightBoxSuccess() {
  return { type: types.SHOW_LIGHTBOX_SUCCESS };
}
